import { Box, Typography } from "@mui/material";
import React from "react";
import { useInView } from "react-intersection-observer";
import { AnimatedNumber } from "../../layouts/Animations/AnimatedNumber";
import {
    statisticBoxStyle,
    statisticDescriptionStyle,
    statisticNameStyle,
    statisticValueStyle,
} from "./statisticItemStyles";

export interface StatisticItemProps {
    statisticName: string;
    statisticValue: number | string;
    statisticDescription: string;
}

const StatisticItem: React.FC<StatisticItemProps> = ({
    statisticName,
    statisticValue,
    statisticDescription,
}) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.3,
    });

    return (
        <Box ref={ref} sx={statisticBoxStyle}>
            <Typography variant="h5" sx={statisticNameStyle}>
                {statisticName}
            </Typography>
            <Typography variant="h3" sx={statisticValueStyle}>
                {inView && typeof statisticValue === "number" ? (
                    <AnimatedNumber value={statisticValue} delay={200} />
                ) : (
                    statisticValue
                )}
            </Typography>
            <Typography variant="body2" sx={statisticDescriptionStyle}>
                {statisticDescription}
            </Typography>
        </Box>
    );
};

export default StatisticItem;
